export enum CreateAccountState {
  Default,
  SignIn,
  SignUp,
}

export interface ISignInFields {
  email: string;
  password: string;
}

export interface ISignUpFields {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
}